import { feedServer } from "@/http";

export default {
    async uploadBanner(_, payload) {
        const banner = payload.banner;
        const bannerFormData = new FormData();
        bannerFormData.append('photo', banner);
        const response = await feedServer.post('/profile/banner/upload', bannerFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (!response.status === 201) {
            const error = 'Failed to create post.';
            throw error;
        }
    },

    async uploadAvatar(_, payload) {
        const avatar = payload.avatar;
        const avatarFormData = new FormData();
        avatarFormData.append('photo', avatar);
        const response = await feedServer.post('/profile/avatar/upload', avatarFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (!response.status === 201) {
            const error = 'Failed to create post.';
            throw error;
        }
    },

    async fetchProfile(context, payload) {
        const response = await feedServer.get(`/profile/${payload.userId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (!response.status === 200) {
            const error = 'Failed to create post.';
            throw error;
        }

        context.commit('setAvatar', {
            avatar: response.data.author.avatar.filename,
        });
        context.commit('setName', {
            name: response.data.author.name,
        });

        return response.data;
    },
}
